export default "__VITE_ASSET__BbPWCFuL__"